<div class="p-3">
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ 'ui.titles.not_authorized' | transloco }}</mat-card-title>
    </mat-card-header>

    <mat-card-actions>
      @if (!isLoggedIn()) {
      <button (click)="onLogin()" class="mr-2" color="primary" id="welcomelogin" mat-raised-button>
        {{ 'ui.buttons.login' | transloco }}
      </button>
      }

      <a [routerLink]="['/']" id="backhomepage" mat-button>
        {{ 'ui.buttons.back_to_homepage' | transloco }}
      </a>
    </mat-card-actions>
  </mat-card>
</div>
